/**
 * Returns true when the app is running inside an Electron shell.
 *
 * Both preload scripts (riveros and selfhosted) expose window.riverOS via
 * contextBridge. This is the canonical, synchronous signal — no userAgent
 * sniffing, no process.env, no undefined window.electronAPI.
 */
export function isElectron(): boolean {
  return typeof window !== 'undefined' && !!(window as any).riverOS;
}

/**
 * True when `dirWatcherIPC` can run (River desktop preload exposes
 * `electron.ipcRenderer.invoke` with `dirwatcher:*` channels). A plain browser
 * tab has neither; self-hosted Electron may expose `riverOS` without this IPC.
 */
export function hasLocalFileSystemIPC(): boolean {
  if (typeof window === 'undefined') return false;
  return typeof (window as any).electron?.ipcRenderer?.invoke === 'function';
}
